module.exports = __webpack_public_path__ + "img/software_img12.d0045302.png";